import { useUserContext } from "../context/UserContext"
import { CountryCode } from "#/utils/CountryCode"
import useGetBenefit from "./useGetBenefit"

export type ProviderRecommendationConfig = {
  showPediatricianRecommendationsForm: boolean
  showObGynRecommendationsForm: boolean
}

type UseShowProviderRecommendationsResult = {
  isLoading: boolean
  isError: boolean
  data: ProviderRecommendationConfig
}

export default function useShowProviderRecommendations(): UseShowProviderRecommendationsResult {
  const { companyCountryCode } = useUserContext()
  const { data: benefit, isLoading: isBenefitLoading, isError: isBenefitError } = useGetBenefit()

  const isUnitedStates = companyCountryCode === CountryCode.United_States
  const providerFinderConfig = !isBenefitLoading ? benefit?.providerFinder : null

  const showPediatricianRecommendationsForm = isUnitedStates && providerFinderConfig?.showPediatricianRecommendations

  const showObGynRecommendationsForm = isUnitedStates && providerFinderConfig?.showObGynRecommendations

  return {
    isLoading: isBenefitLoading,
    isError: isBenefitError,
    data: {
      showPediatricianRecommendationsForm: showPediatricianRecommendationsForm,
      showObGynRecommendationsForm: showObGynRecommendationsForm
    }
  }
}
